import React from 'react';
import { PartnerFormType } from './types';
import { Input, Multiselect } from '@cokitchen/cokitchen-components';

export const bankNames = [
  { text: 'Access Bank', value: 'Access Bank', code: '044' },
  { text: 'Citibank', value: 'Citibank', code: '023' },
  { text: 'Diamond Bank', value: 'Diamond Bank', code: '063' },
  { text: 'Dynamic Standard Bank', value: 'Dynamic Standard Bank', code: '' },
  { text: 'Ecobank Nigeria', value: 'Ecobank Nigeria', code: '050' },
  { text: 'Fidelity Bank Nigeria', value: 'Fidelity Bank Nigeria', code: '070' },
  { text: 'First Bank of Nigeria', value: 'First Bank of Nigeria', code: '011' },
  { text: 'First City Monument Bank', value: 'First City Monument Bank', code: '214' },
  { text: 'Guaranty Trust Bank', value: 'Guaranty Trust Bank', code: '058' },
  { text: 'Heritage Bank Plc', value: 'Heritage Bank Plc', code: '030' },
  { text: 'Wema Bank', value: 'Wema Bank', code: '000' }
];

const PartnerSecondStep = ({
  handleChange,
  bankName,
  setBankName,
  formData
}: {
  handleChange: (e: any) => void;
  bankName: string[];
  setBankName: (item: string[]) => void;
  formData: PartnerFormType;
}) => {
  return (
    <div className='space-y-3'>
      <div>
        <label className='font-medium'>Bank Name</label>
        <Multiselect
          placeholder='Select Bank'
          isSingle
          values={bankName}
          options={bankNames}
          onChange={setBankName}
        />
      </div>
      <Input
        name='account_number'
        label='Account number'
        placeholder='0159009933'
        small
        onChange={handleChange}
        type='number'
        value={formData?.account_number}
      />
      <Input
        name='account_name'
        label='Account name'
        placeholder='Company email'
        small
        onChange={handleChange}
        value={formData?.account_name}
      />
    </div>
  );
};

export default PartnerSecondStep;
